<template>
  <header class="app-header navbar" v-if="$auth.ready()">
    <b-modal v-model="confirmLogoutModal"
      title="Deseja sair?"
      class="modal-primary"
      @ok="logout">

      Deseja sair do Painel administrativo?
    </b-modal>

    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>

    <b-link class="navbar-brand" :to="{ name: 'index' }"></b-link>

    <ul class="navbar-nav flex-row ml-md-auto d-none d-md-flex">
      <li class="item-in-nav-bar">
        <router-link :to="{ name: 'app.dashboard' }">
          <i class="fa fa-home" v-b-tooltip.hover title="Dashboard" aria-hidden="true"></i>
        </router-link>

        <router-link :to="{ name: 'manageables.index', params: { entity: 'sys-users' } }">
          <i class="fa fa-users" v-b-tooltip.hover title="Usuários" aria-hidden="true"></i>
        </router-link>

        <a :href="siteUrl" target="_blank">
          <i class="fa fa-external-link-square"
            v-b-tooltip.hover
            title="Ir para o Site" aria-hidden="true"></i>
        </a>
      </li>

      <!-- /** SEARCH BOX */ -->
      <!--
      <div class="nav-item">
        <b-nav-form class="mx-2 my-auto d-inline">
          <div class="input-group">
            <b-form-input class="" placeholder="Pesquisar" v-model="search"></b-form-input>
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </b-nav-form>
      </div>
      -->

      <!--
      <button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle">
        <span class="navbar-toggler-icon"></span>
      </button>
      -->

      <!-- /** USER DROPDOWN WITH USER/AVATAR/PREFERENCES/LOGOUT */ -->
       <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <b class="user-data">
            {{loggedUser.name || 'Usuário'}}
            <i class="fa fa-chevron-down" aria-hidden="true"></i>
          </b>
        </template>

<!--    <b-dropdown-header tag="div" class="text-center">
          <strong>
            {{ loggedUser.name || '' }} [00:49:01]
            <i class="fa fa-refresh"></i>
          </strong>
        </b-dropdown-header> -->

        <b-dropdown-item :to="{ name: 'app.profile' }">
          <i class="fa fa-user"></i>&nbsp;Perfil
        </b-dropdown-item>

        <b-dropdown-item :to="{ name: 'app.settings' }">
          <i class="fa fa-wrench"></i>&nbsp;Configurações
        </b-dropdown-item>

        <b-dropdown-item @click.prevent="confirmLogoutModal = true">
          <i class="fa fa-lock"></i>&nbsp;Sair
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </ul>
  </header>
</template>

<script>
import config from '@/../config'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'core-header',

  data () {
    return {
      confirmLogoutModal: false,

      search: '',

      siteUrl: config.local.SITE_URL.replace(/"/g, '')
    }
  },

  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      loggedUser: 'auth/user'
    })
  },

  methods: {
    ...mapActions({
      storeToken: 'auth/storeToken',
      revokeToken: 'auth/revokeToken',
      fetchUser: 'auth/fetchUser'
    }),

    logout () {
      const self = this

      self.confirmLogoutModal = false

      self.$auth.logout({
        success () {
          self.revokeToken()
        },
        error (e) {},
        redirect: { name: 'auth.login' }
      })
    },

    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    }
  },

  created () {
    const self = this

    if (self.$auth.check() && !self.isAuthenticated) {
      self.storeToken([self.$auth])
      self.fetchUser()
    }
  }
}
</script>

<style lang="sass">
  .app-header.navbar .navbar-brand
    width: 200px
    transition: none

  .user-data a:hover
    text-decoration: none
    color: #fff !important
</style>



// WEBPACK FOOTER //
// src/components/core/Header.vue